// Price Configuration
// This file contains all pricing-related settings that can be easily modified

export const PRICE_CONFIG = {
  // Per-word rate for translation services
  PER_WORD_RATE: 0.25, // Rs. per word
  
  // Currency settings
  CURRENCY: 'LKR',
  CURRENCY_SYMBOL: 'Rs.',
  
  // Minimum word count (if applicable)
  MIN_WORD_COUNT: 1,
  
  // Maximum word count (if applicable)
  MAX_WORD_COUNT: 100000,
  
  // Discount settings (if applicable)
  DISCOUNTS: {
    // Example: 10% discount for documents with more than 1000 words
    BULK_DISCOUNT: {
      THRESHOLD: 1000,
      PERCENTAGE: 10
    }
  },
  
  // Translation type rates (if different rates for different types)
  TRANSLATION_TYPES: {
    MACHINE: 0.25,
    HUMAN: 0.50, // Example: human translation costs more
    LEGAL: 0.35   // Example: legal documents might have different rates
  }
};

// Helper function to calculate price based on word count
export const calculatePrice = (wordCount, translationType = 'MACHINE') => {
  const rate = PRICE_CONFIG.TRANSLATION_TYPES[translationType.toUpperCase()] || PRICE_CONFIG.PER_WORD_RATE;
  return wordCount * rate;
};

// Helper function to format price for display
export const formatPrice = (price) => {
  return `${PRICE_CONFIG.CURRENCY_SYMBOL} ${price.toFixed(2)}`;
};

// Helper function to get per-word rate for a specific translation type
export const getPerWordRate = (translationType = 'MACHINE') => {
  return PRICE_CONFIG.TRANSLATION_TYPES[translationType.toUpperCase()] || PRICE_CONFIG.PER_WORD_RATE;
};

export default PRICE_CONFIG; 